import {
  TypeKeyValueListFields,
  TypeRedesignHomepageFields,
} from '@/core/generated-types';
import { Asset } from 'contentful';

export const getTranslations = (
  pageFields: TypeRedesignHomepageFields,
  module: string,
) => {
  return pageFields.homepageRedesignTranslations?.filter(
    (entry) => entry.fields.id === module,
  )[0].fields as TypeKeyValueListFields;
};

const minimumLength: { [key: string]: number } = {
  day: 1,
  month: 1,
  year: 4,
};

//  Avoid unnecessary API calls if child info is not correct.
export const isChildInfoCorrect = (childInfo: {
  [key: string]: string;
}): boolean => {
  for (const key in minimumLength) {
    const value = childInfo[key];
    // Ensure the value exists and its length meets the minimum requirement.
    if (!value || value.length < minimumLength[key]) {
      return false;
    }
  }
  return true;
};

export const getSafeImageUrl = (image: Asset) => {
  const url = image.fields.file.url;
  return url.includes('http') ? url : `https:${url}`;
};
